import { render, staticRenderFns } from "./vChart.vue?vue&type=template&id=33bc52ab&scoped=true"
import script from "./vChart.vue?vue&type=script&lang=js"
export * from "./vChart.vue?vue&type=script&lang=js"
import style0 from "./vChart.vue?vue&type=style&index=0&id=33bc52ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc52ab",
  null
  
)

export default component.exports